import { useGetTripsSummary } from 'api/trips/use-get-trips-summary';
import { useTripFiltersStore } from 'shared/stores/use-trip-filters';
import { numberFormatter } from 'shared/utils/numbers/formatter';
import { ListSummary } from 'components/common/list-summary';

export const TripsSummary = () => {
  const { filters, search } = useTripFiltersStore();
  const { data, isLoading } = useGetTripsSummary({ search, filters });

  return (
    <ListSummary isLoading={isLoading}>
      <div>
        Count: {numberFormatter(data?.count || 0)} /{' '}
        <strong>Cost price: {numberFormatter(data?.costPrice || 0)} € / </strong>
        <strong>Cost price by map: {numberFormatter(data?.costPriceByMap || 0)} €</strong>
      </div>
      <div>
        Total LDM: {numberFormatter(data?.totalLDM || 0)} / Total weight: {numberFormatter(data?.totalWeight || 0)} /
        Total volume: {numberFormatter(data?.totalVolume || 0)} / Avg. duration:{' '}
        {numberFormatter(data?.avgDuration || 0)} hrs
      </div>
    </ListSummary>
  );
};
